exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n    --tooltip-background-color: #d8d8dc;\n}\n\n.qm-tooltip .tooltip-inner {\n    color: #212529;\n    background-color: var(--tooltip-background-color)\n}\n\n.qm-tooltip.bs-tooltip-start .arrow::before {\n    border-left-color: var(--tooltip-background-color)\n}\n\n.qm-tooltip.bs-tooltip-end .arrow::before {\n    border-right-color: var(--tooltip-background-color)\n}\n\n.qm-tooltip.bs-tooltip-top .arrow::before {\n    border-top-color: var(--tooltip-background-color)\n}\n\n.qm-tooltip.bs-tooltip-bottom .arrow::before {\n    border-bottom-color: var(--tooltip-background-color)\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/common/tooltip/tooltip.css
// module id = 5983
// module chunks = 0